import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook, Linkedin } from 'lucide-react';
import { useState } from 'react';
import { subscribeNewsletter } from '../lib/api';
import { useLang } from '../context/LanguageContext';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const { c, ui, lp } = useLang();
  const f = ui.footer;

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await subscribeNewsletter(email);
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    } catch {
      setSubscribed(false);
    }
  };

  return (
    <footer className="relative bg-[#0a0a0b] border-t border-white/5 overflow-hidden">
      <div className="relative h-[200px] md:h-[260px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center">
          <h2 className="select-none whitespace-nowrap text-[18vw] md:text-[14vw] font-semibold tracking-tighter text-transparent" style={{ WebkitTextStroke: '1px rgba(255,255,255,0.08)' }}>
            SHINY-CLEANING
          </h2>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 pb-10">
        <div className="grid lg:grid-cols-3 gap-12 lg:gap-16">
          <div>
            <div className="text-white/50 text-[12px] tracking-[0.2em] mb-4 flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[#2f6bff]" /> {f.newsletter}
            </div>
            <h3 className="text-white text-2xl md:text-3xl font-medium mb-4 leading-tight">{f.newsletterTitle}</h3>
            <p className="text-white/50 text-sm mb-6">{f.newsletterText}</p>
            <form onSubmit={submit} className="flex gap-2">
              <input
                type="email"
                placeholder={f.emailPlaceholder}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 bg-white/5 border border-white/10 rounded-md px-4 py-3 text-white text-sm placeholder:text-white/30 focus:outline-none focus:border-[#2f6bff] transition-colors"
              />
              <button type="submit" className="px-5 py-3 rounded-md bg-[#2f6bff] hover:bg-[#1f56e8] text-white text-sm font-medium transition-colors">
                {subscribed ? f.subscribed : f.subscribe}
              </button>
            </form>
          </div>

          <div>
            <div className="text-white/50 text-[12px] tracking-[0.2em] mb-4 flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[#2f6bff]" /> {f.diensten}
            </div>
            <ul className="space-y-3">
              {c.services.slice(0, 6).map(s => (
                <li key={s.slug}>
                  <Link to={lp('service', { slug: s.slug })} className="text-white/70 hover:text-white text-sm transition-colors">
                    {s.title}
                  </Link>
                </li>
              ))}
              <li>
                <Link to={lp('mobile')} className="text-white/70 hover:text-white text-sm transition-colors">
                  {c.nav.find(n => n.key === 'mobile')?.label}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-white/50 text-[12px] tracking-[0.2em] mb-4 flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[#2f6bff]" /> {f.contact}
            </div>
            <ul className="space-y-4 mb-6">
              <li className="flex items-center gap-3 text-white/70 text-sm">
                <Phone className="w-4 h-4 text-[#2f6bff]" /> {c.site.phone}
              </li>
              <li className="flex items-center gap-3 text-white/70 text-sm">
                <Mail className="w-4 h-4 text-[#2f6bff]" /> {c.site.email}
              </li>
              <li className="flex items-center gap-3 text-white/70 text-sm">
                <MapPin className="w-4 h-4 text-[#2f6bff]" /> {c.site.location}
              </li>
            </ul>
            <div className="flex items-center gap-3">
              {[Instagram, Facebook, Linkedin].map((Icon, i) => (
                <a key={i} href="#" aria-label="social" className="w-9 h-9 rounded-md bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center text-white/70 hover:text-white transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col md:flex-row gap-3 justify-between text-white/40 text-xs">
          <div>{f.rights}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
